export enum ScoutFeature {
  StoreFilters = "STOREFILTERS",
  StoreTypeManagement = "STORE_TYPE_MANAGEMENT",
  ServiceThematics = "SERVICE_THEMATICS",
  Mobile = "SCOUT4_MOBILE",
  MyData = "SCOUT4_DATAFORGE",
  Scout4 = "SCOUT4",
  Visualization = "SCOUT_VISUALIZATION",
  ViewReportsOnMap = "SCOUT_VIEW_REPORTS_ON_MAP",
  Toolbox = "SCOUT_TOOLBOX",
  Territories = "SCOUT_TERRITORIES",
  StoreLifecycle = "SCOUT_STORE_LIFE_CYCLE",
  StoreExplore = "SCOUT_STORE_EXPLORE",
  SegmentationGuide = "SCOUT_SEGMENTATION_GUIDE",
  Results = "SCOUT_RESULTS",
  Reports = "SCOUT_REPORTS_ALTERYX",
  NationalProfiles = "SCOUT_NATIONAL_PROFILES",
  MyDataStoreImport = "SCOUT_MY_DATA_STORE_IMPORT",
  MobileSiteScore = "SCOUT_MOBILE_SITE_SCORE",
  ManageLocation = "SCOUT_MANAGE_LOCATION",
  HouseholdAnalysis = "SCOUT_HOUSEHOLD_ANALYSIS",
  HealthcareVisitsData = "SCOUT_HEALTHCARE_VISITS_DATA",
  HealthcareDrgData = "SCOUT_HEALTHCARE_DRG_DATA",
  HealthcareData = "SCOUT_HEALTHCARE_DATA",
  PotentialCustomerData = "SCOUT_HAS_POTENTIAL_CUSTOMER_DATA",
  ActualCustomerData = "SCOUT_HAS_ACTUAL_CUSTOMER_DATA",
  GeographyExplore = "SCOUT_GEOGRAPHY_EXPLORE",
  FileBrowser = "SCOUT_FILE_BROWSER",
  Favorites = "SCOUT_FAVORITES",
  Traffic = "SCOUT_ENHANCED_TRAFFIC",
  DemandAnalysis = "SCOUT_DEMAND_ANALYSIS",
  Competitors = "SCOUT_COMPETITORS",
  CompanyManagement = "SCOUT_COMPANY_MANAGEMENT",
  CommunityCollaborateProspects = "SCOUT_COMMUNITY_COLLABORATE_PROSPECTS",
  CommunityCollaborateContacts = "SCOUT_COMMUNITY_COLLABORATE_CONTACTS",
  CommunityCollaborateContactActivity = "SCOUT_COMMUNITY_COLLABORATE_CONTACT_ACTIVITY",
  CollaborateVisualization = "SCOUT_COLLABORATE_VISUALIZATION",
  CollaborateTerritories = "SCOUT_COLLABORATE_TERRITORIES",
  CollaborateReportHistory = "SCOUT_COLLABORATE_REPORT_HISTORY",
  CollaboratePushpins = "SCOUT_COLLABORATE_PUSHPINS",
  CollaborateLocationFilters = "SCOUT_COLLABORATE_LOCATION_FILTERS",
  CollaborateGpsInsights = "SCOUT_COLLABORATE_GPS_INSIGHTS",
  Collaborate = "SCOUT_COLLABORATE",
  Clusters = "SCOUT_CLUSTERS",
  BuxtonData = "SCOUT_BUXTON_DATA",
  BusinessAnalysis = "SCOUT_BUSINESS_ANALYSIS",
  BatchReports = "SCOUT_BATCH_REPORTS",
  AreasOfInterest = "SCOUT_AREAS_OF_INTEREST",
  AdminTools = "SCOUT_ADMIN_TOOLS",
  SalesPerformance = "SALES_PERFORMANCE",
  RetailMatch = "RETAIL_MATCH", // community only
  TwoByTwo = "PLATFORM_2_BY_2",
  MyMarket = "MY_MARKET",
  Intercom = "SCOUT_INTERCOM",
  IntercomConversation = "INTERCOM_CONVERSATION",
  GpsInsights = "GPS_INSIGHTS",
  RetailMatchReports = "RETAIL_MATCH_REPORTS",
  CollaborateRetailMatchReports = "SCOUT_COLLABORATE_RETAIL_MATCH_REPORTS",
  UserSettings = "USER_SETTINGS",
  /** The free version */
  MobilyticsPro = "MOBILYTICS_PRO",
  /** The paid version */
  MobilyticsPaid = "MOBILYTICS_PAID",
  UserSettingsUploadImage = "USER_SETTINGS_UPLOAD_IMAGE",
  /** Access to the Factor application. */
  Factor = "FACTOR",
  /** Access to the IQ application. */
  IQ = "IQ",
  /** Access the Planning Tab */
  Planning = "PLANNING",
  /** Access the Analyze application */
  Analyze = "ANALYZE",
  /** Access to Configurable Reports. */
  ConfigurableReporting = "CONFIGURABLE_REPORTING",
  /** Access to Inactivity Timeout Management */
  InactivityTimeout = "INACTIVITY_TIMEOUT_MANAGEMENT",
  /** Access to Target Market feature */
  TargetMarket = "SCOUT_TARGET_MARKET",
  /** Access to the Persona+ feature */
  Persona = "BREAKFAST_WITH_BUXTON",
}
